interface MessageItem {
  cz: string;
  en: string;
  pl: string;
}

export type Messages = {
  [key: string]: MessageItem;
}

export const messages: Messages = {
  "PageNotFound": {
    cz: 'Stránka nenalezena',
    pl: 'Strona nie znaleziona',
    en: 'Page Not found'
  },
  "Zpět do IREDA": {
    "en": "Back to IREDO",
    "cz": "Zpět do IREDA",
    "pl": "Powrót do IREDA"
  },

  "zavřít": {
    "en": "close",
    "cz": "zavřít",
    "pl": "zamknąć"
  },

  "today": {
    "en": "today",
    "cz": "dnes",
    "pl": "dzisiaj"
  },

  "Výběr jazyka": {
    "en": "Language selection",
    "cz": "Výběr jazyka",
    "pl": "Wybór języka"
  },

  "Kliknutím provedete zavření hlášení.": {
    "en": "Click to close the message.",
    "cz": "Kliknutím provedete zavření hlášení.",
    "pl": "Kliknij, aby zamknąć zgłoszenie."
  },

  "Spoje": {
    "en": "Vehicles",
    "cz": "Spoje",
    "pl": "Pojazdy"
  },

  "Zastávky": {
    "en": "Stations",
    "cz": "Zastávky",
    "pl": "Stacje"
  },

  "Kontakt": {
    "en": "Contact",
    "cz": "Kontakt",
    "pl": "Kontakt"
  },

  "Jedoucí spoje": {
    "en": "Running vehicles",
    "cz": "Jedoucí spoje",
    "pl": "Jeżdżące pojazdy"
  },
  "Vyhledání jedoucího spoje": {
    "en": "Search running vehicles",
    "cz": "Vyhledání jedoucího spoje",
    "pl": "Wyszukiwanie połączeń"
  },
  "Vyhledání zastávky": {
    "en": "Search station",
    "cz": "Vyhledání zastávky",
    "pl": "Wyszukiwanie przystanku"
  },
  "Vyhledání odjezdů ze zastávky": {
    "en": "Search departures of station",
    "cz": "Vyhledání odjezdů ze zastávky",
    "pl": "Wyszukiwanie odjazdów z przystanku"
  },
  "Vyhledání kontaktního místa": {
    "en": "Search Contact Place",
    "cz": "Vyhledání kontaktního místa",
    "pl": "Wyszukiwanie punktu kontaktowego"
  },

  "Moje poloha": {
    "en": "My location",
    "cz": "Moje poloha",
    "pl": "Moja lokalizacja"
  },
  "Skrýt moji polohu": {
    "en": "Hide my location",
    "cz": "Skrýt moji polohu",
    "pl": "Ukryj moją lokalizację"
  },

  "Otevřít Streetview": {
    "en": "Open Streetview",
    "cz": "Otevřít Streetview",
    "pl": "Otwórz Streetview"
  },

  "včas": {
    "en": "on time",
    "cz": "včas",
    "pl": "na czas"
  },
  "směr": {
    "en": "direction",
    "cz": "směr",
    "pl": "kierunek"
  },

  "Název spoje...": {
    "en": "Connection name...",
    "cz": "Název spoje...",
    "pl": "Nazwa połączenia..."
  },
  "Název zastávky...": {
    "en": "Stop name...",
    "cz": "Název zastávky...",
    "pl": "Nazwa przystanku..."
  },
  "Název místa...": {
    "en": "Place name...",
    "cz": "Název místa...",
    "pl": "Nazwa miejsca..."
  },
  "na znamení": {
    "en": "request stop",
    "cz": "na znamení",
    "pl": "na żądanie"
  },
  "bez bariér": {
    "en": "station is wheelchair accessible",
    "cz": "stanice je bezbariérově přístupná",
    "pl": "stacja jest przystosowana dla osób niepełnosprawnych"
  },
  "občerstvení": {
    "en": "catering available",
    "cz": "občerstvení k dispozici",
    "pl": "catering dostępny"
  },
  "nevidomí": {
    "en": "station is accessible for blind people",
    "cz": "stanice je uzpůsobena pro nevidomé",
    "pl": "stacja jest dostępna dla osób niewidomych"
  },
  "zóna": {
    "en": "zone",
    "cz": "zóna",
    "pl": "strefa"
  },
  "zóny": {
    "en": "zones",
    "cz": "zóny",
    "pl": "strefy"
  },
  "příjezd": {
    "en": "arrival",
    "cz": "příjezd",
    "pl": "przyjazd"
  },
  "odjezd": {
    "en": "departure",
    "cz": "odjezd",
    "pl": "wyjazd"
  },

  "Vlaková stanice": {
    "en": "Train Station",
    "cz": "Vlaková stanice",
    "pl": "Vlaková stanice"
  },
  "Autobusová zastávka": {
    "en": "Bus stop",
    "cz": "Autobusová zastávka",
    "pl": "Przystanek autobusowy"
  },
  "Naposledy hledané zastávky": {
    "en": "Last stations searched",
    "cz": "Naposledy hledané zastávky",
    "pl": "Ostatnio wyszukiwane przystanki"
  },
  "Nebyla nalezena žádná zastávka s tímto názvem.": {
    "en": "There is no station with specified name.",
    "cz": "Nebyla nalezena žádná zastávka s tímto názvem.",
    "pl": "Nie znaleziono żadnego przystanku o tej nazwie."
  },
  "Nebyl nalezen žádný spoj s tímto názvem.": {
    "en": "There is no running vehicle with specified name.",
    "cz": "Nebyl nalezen žádný spoj s tímto názvem.",
    "pl": "Nie znaleziono żadnego połączenia o tej nazwie."
  },
  "Odjezdy ze zastávky": {
    "en": "Departures from stop",
    "cz": "Odjezdy ze zastávky",
    "pl": "Odjazdy z przystanku"
  },
  "Žádné odjezdy v nejbližších dvou hodinách.": {
    "en": "No departures in two hours.",
    "cz": "Žádné odjezdy v nejbližších dvou hodinách.",
    "pl": "Żadnych odjazdów w ciągu najbliższych dwóch godzin."
  },

  "Otevřeno": {
    "en": "Open",
    "cz": "Otevřeno",
    "pl": "Otwarte"
  },

  "Nebylo nalezeno kontaktní místo s tímto názvem.": {
    "en": "There is no contact place with specified name.",
    "cz": "Nebylo nalezeno kontaktní místo s tímto názvem.",
    "pl": "Nie znaleziono punktu kontaktowego o tej nazwie."
  },

  "Spoj jede po lince s výlukovým jízdním řádem.": {
    "en": "The train runs on a line with a temporary timetable.",
    "cz": "Spoj jede po lince s výlukovým jízdním řádem.",
    "pl": "Linia kursuje zgodnie z rozkładem jazdy obowiązującym w okresie zamknięcia linii."
  }
};
